<template>
    <base-stripe
      :successRedirectURL="'/my-cart/checkout/success'"
      :failedRedirectURL="'/my-cart/checkout/failed'"/>
  </template>

  <script>
  import BaseStripe from "@/views/PaymentGateway/BaseStripe";

  export default {
    name: "StripePayment",
    components: {
      BaseStripe,
    },
  };
  </script>
